import React from "react";
import "./App.css";
import { Array } from "./components/Array";

function App() {
  return (
    <div className="App">
      <main className="main">
        <section>
          <Array />
        </section>
      </main>
    </div>
  );
}

export default App;
